import { render, staticRenderFns } from "./indexV3.vue?vue&type=template&id=8b4b18c8&scoped=true"
import script from "./indexV3.vue?vue&type=script&lang=js"
export * from "./indexV3.vue?vue&type=script&lang=js"
import style0 from "./indexV3.vue?vue&type=style&index=0&id=8b4b18c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4b18c8",
  null
  
)

export default component.exports